<template>
  <v-edit-dialog @save="saveTip" persistent large>
    {{ model.value }}
    <template v-slot:input>
      <v-select :items="items" v-model="model.value" label="Tip"></v-select>
    </template>
  </v-edit-dialog>
</template>

<script>
export default {
  data: () => ({
    items:[
      { text: "PARALLEL", value: "PARALLEL" },
      { text: "TAPER", value: "TAPER" },
      { text: "FLEXIBLE", value: "FLEXIBLE" },
    ],
    model:{},
  }),
  props: {
    field: {
      type: Object
    }
  },
  mounted: function() {
    this.model = this.field;
  },
  watch: {
    field() {
      this.model = this.field;
    }
  },
  methods: {
    saveTip() {
      this.loading = true;
      this.$store
        .dispatch("productSets/updateField", {
          model: this.model
        })
        .then(data => (this.model = data))
        .finally(() => {
          this.$store.dispatch("app/displaySnackBar", {
            text: "Set updated",
            color: "#28a745"
          });
        });
    }
  }
};
</script>

<style>
</style>